export default __webpack_public_path__ + "static/media/ImgLawEnforcement.9c011515.jpg";